<ng-container *ngIf="isSearchResultsOpen" #appSearchResults>

	<div style="height: 250px; width: 600px; overflow: auto;" class="bg-white">
		<table 
			class="table table-striped mat-table cdk-table mat-sort align-middle" 
			role="table" 
			mat-table [dataSource]="dataSource"
			matSort>
			<ng-container matColumnDef="source">
				<th mat-header-cell *matHeaderCellDef>Type</th>
				<td mat-cell *matCellDef="let element">{{element.source}}</td>
			</ng-container>

			<ng-container matColumnDef="title">
				<th mat-header-cell *matHeaderCellDef>Title</th>
				<td mat-cell *matCellDef="let element">{{element.title}}</td>
			</ng-container>

			<ng-container matColumnDef="description">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
				<td mat-cell *matCellDef="let element">{{element.description}}</td>
			</ng-container>

			<ng-container matColumnDef="details">
				<th mat-header-cell *matHeaderCellDef>Detail</th>
				<td class="relative" mat-cell *matCellDef="let element">
					<button mat-icon-button color="primary" (click)="redirectToDetails(element)">
						<mat-icon class="mat-18">reorder</mat-icon>
					</button>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="redirectToDetails(row)"></tr>
		</table>
	</div>

</ng-container>